// Выбор роли и областей: у каждой роли — строка-пояснение (FR-024а; ux.md, раздел 12).
// До 003 область одна — «Вся установка»; у администратора клиента и сопровождения выбора нет
// (FR-013в).
import { isInstallationOnlyRole, roleInfo, roles } from '@kp/contracts';
import type { Role } from '@kp/contracts';
import type { PickerOption } from '@kp/ui';

export function capitalize(text: string): string {
  return text ? text.charAt(0).toLocaleUpperCase('ru-RU') + text.slice(1) : text;
}

/** Пояснение роли с заглавной буквы: «Справочники, очереди, сообщения…». */
export function roleDescription(role: Role): string {
  return capitalize(roleInfo[role].description);
}

export const roleOptions: readonly PickerOption<Role>[] = roles.map((role) => ({
  value: role,
  label: roleInfo[role].title,
  description: roleDescription(role),
}));

export type AreaChoice = 'installation';

export const areaOptions: readonly PickerOption<AreaChoice>[] = [
  { value: 'installation', label: 'Вся установка' },
];

export const AREAS_FIXED_REASON = 'У администратора клиента и сопровождения — только вся установка';
export const AREAS_HINT = 'Другие области появятся вместе со справочниками объектов';

export function areasHint(role: Role | null): { hint?: string; disabled: boolean } {
  return role !== null && isInstallationOnlyRole(role)
    ? { disabled: true }
    : { hint: AREAS_HINT, disabled: false };
}
